import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsAmendmentStageReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsAmendmentStageReducer;
